import React, { useState } from 'react'
import styles from './CurrentCharges.module.css'
import useCountUp from './useCountUp'

const CurrentCharges = ({
  amount = 2.64,
  minutes = 22,
  rate = 0.12,
  note = 'Charges update in real-time as you use minutes',
}) => {
  const animated = useCountUp(amount, { duration: 1200, decimals: 2 })
  const [open, setOpen] = useState(false)

  return (
    <div className={styles.card}>
      <button
        type="button"
        className={styles.head}
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <h3 className={styles.title}>Current Charges</h3>
        <span className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}>›</span>
      </button>

      <div className={`${styles.collapse} ${open ? styles.collapseOpen : ''}`}>
        <div className={styles.collapseInner}>
          <div className={styles.body}>
            <div className={styles.iconWrap}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                <rect x="5" y="3" width="14" height="18" rx="2" stroke="#F87A5D" strokeWidth="1.7" />
                <path d="M9 7h6M9 11h6M9 15h4" stroke="#F87A5D" strokeWidth="1.7" strokeLinecap="round" />
              </svg>
            </div>
            <div>
              <p className={styles.amount}>${animated.toFixed(2)}</p>
              <p className={styles.breakdown}>{minutes} min × ${rate.toFixed(2)}/min</p>
            </div>
          </div>

          <div className={styles.note}>
            <span className={styles.noteIcon}>!</span>
            <p className={styles.noteText}>{note}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CurrentCharges
